class YoutubeVideoThumbnail extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.button = this.querySelector('.youtube-video-thumbnail__button');
    this.player = this.querySelector('.youtube-video-thumbnail__player');
    this.overlay = this.querySelector('.youtube-video-thumbnail__overlay-content');

    if (!this.button || !this.player || this.button.disabled) return;
    this.initialized = true;
    this.closeButton = document.createElement('button');
    this.closeButton.type = 'button';
    this.closeButton.className = 'youtube-video-thumbnail__close';
    this.closeButton.textContent = 'Close video ×';
    this.closeButton.hidden = true;
    this.appendChild(this.closeButton);
    this.closeButton.addEventListener('click', () => this.closeVideo());
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.player.hidden) this.closeVideo();
    });

    this.button.addEventListener('click', (event) => {
      // A campaign link in the overlay must navigate without starting playback.
      if (event.target.closest('a')) return;
      this.playVideo();
    });
  }

  playVideo() {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const videoId = isMobile
      ? this.dataset.mobileVideoId || this.dataset.desktopVideoId
      : this.dataset.desktopVideoId || this.dataset.mobileVideoId;

    if (!videoId || !this.player.hidden) return;

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&mute=1&rel=0`;
    iframe.setAttribute('title', this.getAttribute('aria-label') || 'YouTube video');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    iframe.setAttribute('allowfullscreen', '');

    this.player.replaceChildren(iframe);
    this.player.hidden = false;
    this.button.hidden = true;
    if (this.overlay) this.overlay.hidden = true;
    this.closeButton.hidden = false;
    this.closeButton.focus();
  }

  closeVideo() {
    this.player.replaceChildren();
    this.player.hidden = true;
    this.button.hidden = false;
    if (this.overlay) this.overlay.hidden = false;
    this.closeButton.hidden = true;
    this.button.focus();
  }

  disconnectedCallback() {
    // Removing a section in the theme editor must also stop its video.
    this.player?.replaceChildren();
    if (this.player) this.player.hidden = true;
    if (this.button) this.button.hidden = false;
    if (this.overlay) this.overlay.hidden = false;
    if (this.closeButton) this.closeButton.hidden = true;
  }
}

if (!customElements.get('youtube-video-thumbnail')) {
  customElements.define('youtube-video-thumbnail', YoutubeVideoThumbnail);
}
